;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React, { useContext } from 'react';

import PropTypes from 'prop-types';

import SocialLink from 'components/globals/Footer/SocialLink';

import Button from 'components/ui/Button';
import Icon from 'components/ui/Icon';
import Text from 'components/ui/Text';

import ContactContext from '../Context';

import styles from './EndState.module.scss';

const EndState = ({
    headline = 'thank you',
    body = 'We’re on it! A Tillamook team member will reach out as soon as possible.',
    socialLinks,
}) => {
    const { handleReset } = useContext(ContactContext);

    return (
        <div className={styles.root}>
            <Icon
                className={styles.icon}
                src="https://images.ctfassets.net/j8tkpy1gjhi5/66jv9aNXjx2KIf7uaDJonP/23b6a8ac56ae79a7b9649471fd9163c6/Checkmark.svg"
            />
            <Text
                className={styles.headline}
                as="h2"
                baseTheme="displaySmall"
                themes={{ medium: 'displayLarge' }}
            >
                {headline}
            </Text>
            <Text
                className={styles.body}
                baseTheme="bodyMedium"
                themes={{ medium: 'bodyLarge' }}
            >
                {body}
            </Text>
            <Button
                theme="filledBlueHoverCream-ultrabold"
                className={styles.resetButton}
                onClick={handleReset}
            >
                Start Over
            </Button>
            <div className={styles.social}>
                {socialLinks &&
                    socialLinks.length &&
                    socialLinks.map((data, i) => {
                        return (
                            <SocialLink
                                key={i}
                                href={data.url}
                                platform={data.platform}
                            />
                        );
                    })}
            </div>
        </div>
    );
};

EndState.propTypes = {
    body: PropTypes.string,
    headline: PropTypes.string,
    socialLinks: PropTypes.array,
};

export default EndState;
